export default "__VITE_ASSET__DTRfjCtm__"